/* eslint-disable no-unused-vars */
const account = {
  type:'account',
  placeholder:''
}

const account_creation_fee = {
  type:'asset',
  placeholder:''
}

const account_to_recover = {
  type:'account',
  placeholder:''
}

const account_to_reset = {
  type:'account',
  placeholder:''
}

const active = {
  type:'object',
  placeholder:'Active authority'
}

const agent = {
  type:'account',
  placeholder:''
}

const allow_curation_rewards = {
  type:'boolean',
  placeholder:''
}

const allow_votes = {
  type:'boolean',
  placeholder:''
}

const amount = {
  type:'asset',
  placeholder:''
}

const amount_to_sell = {
  type:'asset',
  placeholder:''
}

const approve = {
  type:'boolean',
  placeholder:''
}

const author = {
  type:'account',
  placeholder:''
}

const auto_vest = {
  type:'boolean',
  placeholder:''
}

const block_signing_key = {
  type:'public_key',
  placeholder:''
}

const body = {
  type:'textarea',
  rows: 10,
  placeholder:''
}

const creator = {
  type:'account',
  placeholder:''
}

const current_reset_account = {
  type:'asset',
  placeholder:''
}

const data = {
  type:'buffer',
  placeholder:''
}

const daily_pay = {
  type:'asset',
  placeholder:''
}

const decline = {
  type:'boolean',
  placeholder:''
}

const delegatee = {
  type:'account',
  placeholder:''
}

const delegation = {
  type:'asset',
  placeholder:''
}

const delegator = {
  type:'account',
  placeholder:''
}

const end_date = {
  type:'time',
  placeholder:''
}

const escrow_expiration = {
  type:'time',
  placeholder:''
}

const escrow_id = {
  type:'number',
  placeholder:''
}

const exchange_rate = {
  type:'object',
  placeholder:''
}

const expiration = {
  type:'time',
  placeholder:''
}

const extensions = {
  type:'object',
  placeholder:''
}

const fee = {
  type:'asset',
  placeholder:''
}

const fill_or_kill = {
  type:'boolean',
  placeholder:''
}

const first_block = {
  type:'string',
  placeholder:''
}

const from = {
  type:'account',
  placeholder:''
}

const from_account = {
  type:'account',
  placeholder:''
}

const id = { //used in custom_json and custom_binary
  type:'string',
  placeholder:''
}

const input = {
  type:'string',
  placeholder:''
}

const json = {
  type:'json',
  placeholder:''
}

const json_meta = {
  type:'json',
  placeholder:''
}

const json_metadata = {
  type:'json',
  placeholder:''
}

const max_accepted_payout = {
  type:'asset',
  placeholder:''
}

const maximum_block_size = {
  type:'string',
  placeholder:''
}

const memo = {
  type:'string',
  placeholder:''
}

const memo_key = {
  type:'public_key',
  placeholder:''
}

const min_to_receive = {
  type:'asset',
  placeholder:''
}

const new_account_name = {
  type:'string',
  placeholder:''
}

const new_owner_authority = {
  type:'object',
  placeholder:''
}

const new_recovery_account = {
  type:'account',
  placeholder:''
}

const nonce = {
  type:'string',
  placeholder:''
}

const orderid = {
  type:'number',
  placeholder:''
}

const owner = {
  type:'object',
  placeholder:'Owner authority'
}

const parent_author = {
  type:'account',
  placeholder:'Leave empty for posts'
}

const parent_permlink = {
  type:'string',
  placeholder:'Principal tag (for posts) or parent permlink (for comments)'
}

const percent = {
  type:'number',
  placeholder:''
}

const percent_steem_dollars = {
  type:'number',
  placeholder:''
}

const permlink = {
  type:'string',
  placeholder:''
}

const posting = {
  type:'object',
  placeholder:'Posting authority'
}

const posting_json_metadata = {
  type:'json',
  placeholder:''
}

const pow_summary = {
  type:'string',
  placeholder:''
}

const prev_block = {
  type:'string',
  placeholder:''
}

const proof = {
  type:'string',
  placeholder:''
}

const proposal_ids = {
  type:'object',
  placeholder:''
}

const proposal_owner = {
  type:'account',
  placeholder:''
}

const props = {
  type:'object',
  placeholder:''
}

const proxy = {
  type:'account',
  placeholder:''
}

const publisher = {
  type:'string',
  placeholder:''
}

const ratification_deadline = {
  type:'time',
  placeholder:''
}

const receiver = {
  type:'account',
  placeholder:''
}

const recent_owner_authority = {
  type:'object',
  placeholder:''
}

const recovery_account = {
  type:'account',
  placeholder:''
}

const reporter = {
  type:'string',
  placeholder:''
}

const request_id = {
  type:'number',
  placeholder:''
}

const requestid = {
  type:'number',
  placeholder:''
}

const required_active_auths = {
  type:'object',
  placeholder:''
}

const required_auths = {
  type:'object',
  placeholder:''
}

const required_owner_auths = {
  type:'object',
  placeholder:''
}

const required_posting_auths = {
  type:'object',
  placeholder:''
}

const reset_account = {
  type:'account',
  placeholder:''
}

const reward_sbd = {
  type:'asset',
  placeholder:''
}

const reward_steem = {
  type:'asset',
  placeholder:''
}

const reward_vests = {
  type:'asset',
  placeholder:''
}

const sbd_amount = {
  type:'asset',
  placeholder:''
}

const sbd_interest_rate = {
  type:'string',
  placeholder:''
}

const second_block = {
  type:'string',
  placeholder:''
}

const signature = {
  type:'string',
  placeholder:''
}

const start_date = {
  type:'time',
  placeholder:''
}

const steem_amount = {
  type:'asset',
  placeholder:''
}

const subject = {
  type:'string',
  placeholder:''
}

const title = {
  type:'string',
  placeholder:''
}

const to = {
  type:'account',
  placeholder:''
}

const to_account = {
  type:'account',
  placeholder:''
}

const url = {
  type:'string',
  placeholder:''
}

const vesting_shares = {
  type:'asset',
  placeholder:''
}

const voter = {
  type:'account',
  placeholder:''
}

const weight = {
  type:'number',
  placeholder:''
}

const who = {
  type:'account',
  placeholder:''
}

const witness = {
  type:'account',
  placeholder:''
}

const work = {
  type:'string',
  placeholder:''
}

const worker = {
  type:'string',
  placeholder:''
}

const worker_account = {
  type:'account',
  placeholder:''
}

// STEEM ENGINE

const symbol = {
  type:'string',
  placeholder:''
}

const quantity = {
  type:'float-string',
  placeholder:''
}

const price = {
  type:'float-string',
  placeholder:''
}

const type_se = {
  type:'string',
  placeholder:''
}

const id_se = {
  type:'string',
  placeholder:''
}

/**
 * account_create
 */
const account_create = {
  name: 'Create account',
  operation: 'account_create',
  authorities: ['active'],
  description:
`
Create a new account in the steem blockchain.

The authorities must be filled in JSON format. Example:
 {"weight_threshold":1,"account_auths":[],"key_auths":[["STM6MNBPuAEiCAYgVs6DSHrw3BBEbxicSug1xnL8amTbfotPSume5",1]]}
`,
  params: {
    fee,
    creator,
    new_account_name,
    owner,
    active,
    posting,
    memo_key,
    json_metadata
  }
}

/**
 * account_create_with_delegation
 */
const account_create_with_delegation = {
  authorities: ['active'],
  description:
`
This operation is deprecated as of Hardfork 20
`,
  params: {
    fee,
    delegation,
    creator,
    new_account_name,
    owner,
    active,
    posting,
    memo_key,
    json_metadata,
    extensions
  }
}

/**
 * account_update
 */
const account_update = {
  authorities: ['owner', 'active'],
  description:
`

`,
  params: {
    account,
    owner,
    active,
    posting,
    memo_key,
    json_metadata
  },
  optional: ['owner','active','posting']
}

/**
 * account_update2
 */
const account_update2 = {
  authorities: ['owner', 'active', 'posting'],
  description:
`

`,
  params: {
    account,
    owner,
    active,
    posting,
    memo_key,
    json_metadata,
    posting_json_metadata,
  },
  optional: ['owner','active','posting']
}

/**
 * account_witness_proxy
 */
const account_witness_proxy = {
  authorities: ['active'],
  description:
`

`,
  params: {
    account,
    proxy
  }
}

/**
 * account_witness_vote
 */
const account_witness_vote = {
  authorities: ['active'],
  description:
`

`,
  params: {
    account,
    witness,
    approve
  }
}

/**
 * cancel_transfer_from_savings
 */
const cancel_transfer_from_savings = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    request_id
  }
}

/**
 * change_recovery_account
 */
const change_recovery_account = {
  authorities: ['owner'],
  description:
`

`,
  params: {
    account_to_recover,
    new_recovery_account,
    extensions
  }
}

/**
 * claim_reward_balance
 */
const claim_reward_balance = {
  authorities: ['posting'],
  description:
`

`,
  params: {
    account,
    reward_steem,
    reward_sbd,
    reward_vests
  }
}

/**
 * claim_account
 */
const claim_account = {
  authorities: ['active'],
  description:
`

`,
  params: {
    creator,
    fee,
    extensions
  }
}

/**
 * comment
 */
const comment = {
  authorities: ['posting'],
  description:
`
Operation to create posts and comments.
For posts parent_author is empty and parent_permlink is the principal tag.
For comments use the actual parent_author and parent_permlink.
`,
  params: {
    parent_author,
    parent_permlink,
    author,
    permlink,
    title,
    body,
    json_metadata
  }
}

/**
 * comment_options
 */
const comment_options = {
  authorities: ['posting'],
  description:
`
To set beneficiaries use the extensions:
[[0,{"beneficiaries":[{"account":"alice","weight":1000},{"account":"bob","weight":1000}]}]]
`,
  params: {
    author,
    permlink,
    max_accepted_payout,
    percent_steem_dollars,
    allow_votes,
    allow_curation_rewards,
    extensions
  }
}

/**
 * convert
 */
const convert = {
  authorities: ['active'],
  description:
`

`,
  params: {
    owner: account,
    requestid,
    amount
  }
}

/**
 * create_claimed_account
 */
const create_claimed_account = {
  authorities: ['active'],
  description:
`

`,
  params: {
    creator,
    new_account_name,
    owner,
    active,
    posting,
    memo_key,
    json_metadata,
    extensions
  }
}

/**
 * create_proposal
 */
const create_proposal = {
  authorities: ['active'],
  description:
`

`,
  params: {
    creator,
    receiver,
    start_date,
    end_date,
    daily_pay,
    subject,
    permlink,
    extensions
  }
}

/**
 * custom
 */
const custom = {
  authorities: ['active'], //for required_auths
  description:
`
Provides a generic way to add higher level protocols on top of witness consensus.
The data is saved as buffer.
`,
  params: {
    required_auths,
    id,
    data
  }
}

/**
 * custom_binary
 */
const custom_binary = {
  authorities: ['owner','active','posting'],
  description:
`
posting for required_posting_auths,
active for required_active_auths,
owner for required_owner_auths,
extra authorities in required_auths
`,
  params: {
    required_owner_auths,
    required_active_auths,
    required_posting_auths,
    required_auths,
    id,
    data
  }
}

/**
 * custom_json
 */
const custom_json = {
  authorities: ['active','posting'],
  description:
`
posting for required_posting_auths,
active for required_auths
`,
  params: {
    required_auths,
    required_posting_auths,
    id,
    json
  }
}

/**
 * decline_voting_rights
 */
const decline_voting_rights = {
  authorities: ['owner'],
  description:
`

`,
  params: {
    account,
    decline
  }
}

/**
 * delegate_vesting_shares
 */
const delegate_vesting_shares = {
  authorities: ['active'],
  description:
`

`,
  params: {
    delegator,
    delegatee,
    vesting_shares
  }
}

/**
 * delete_comment
 */
const delete_comment = {
  authorities: ['posting'],
  description:
`

`,
  params: {
    author,
    permlink
  }
}


/**
 * escrow_approve
 */
const escrow_approve = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    agent,
    who,
    escrow_id,
    approve
  }
}

/**
 * escrow_dispute
 */
const escrow_dispute = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    agent,
    who,
    escrow_id
  }
}

/**
 * escrow_release
 */
const escrow_release = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    agent,
    who,
    receiver,
    escrow_id,
    sbd_amount,
    steem_amount
  }
}

/**
 * escrow_transfer
 */
const escrow_transfer = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    agent,
    escrow_id,
    sbd_amount,
    steem_amount,
    fee,
    ratification_deadline,
    escrow_expiration,
    json_meta
  }
}

/**
 * feed_publish
 */
const feed_publish = {
  authorities: ['active'],
  description:
`
For exchange rate use base and quote:
{"base":"3.000 SBD","quote":"1.000 STEEM"}
`,
  params: {
    publisher,
    exchange_rate
  }
}

/**
 * limit_order_cancel
 */
const limit_order_cancel = {
  authorities: ['active'],
  description:
`

`,
  params: {
    owner: account,
    orderid
  }
}

/**
 * limit_order_create
 */
const limit_order_create = {
  authorities: ['active'],
  description:
`

`,
  params: {
    owner: account,
    orderid,
    amount_to_sell,
    min_to_receive,
    fill_or_kill,
    expiration
  }
}

/**
 * limit_order_create2
 */
const limit_order_create2 = {
  authorities: ['active'],
  description:
`
For exchange rate use base and quote:
{"base":"3.000 SBD","quote":"1.000 STEEM"}
`,
  params: {
    owner: account,
    orderid,
    amount_to_sell,
    fill_or_kill,
    exchange_rate,
    expiration
  }
}

/**
 * recover_account
 */
const recover_account = {
  authorities: [],
  description:
`
This transaction must be signed by recent_owner_authority and new_owner_authority
`,
  params: {
    account_to_recover,
    new_owner_authority,
    recent_owner_authority,
    extensions
  }
}

/**
 * remove_proposal
 */
const remove_proposal = {
  authorities: [],
  description:
`

`,
  params: {
    proposal_owner,
    proposal_ids,
    extensions
  }
}

/**
 * request_account_recovery
 */
const request_account_recovery = {
  authorities: ['active'],
  description:
`
Requires the active signature of the recovery_account
`,
  params: {
    recovery_account,
    account_to_recover,
    new_owner_authority,
    extensions
  }
}

/**
 * set_withdraw_vesting_route
 */
const set_withdraw_vesting_route = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from_account,
    to_account,
    percent,
    auto_vest
  }
}

/**
 * transfer
 */
const transfer = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    amount,
    memo
  }
}

/**
 * transfer_from_savings
 */
const transfer_from_savings = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    request_id,
    to,
    amount,
    memo
  }
}


/**
 * transfer_to_savings
 */
const transfer_to_savings = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    amount,
    memo
  }
}

/**
 * transfer_to_vesting
 */
const transfer_to_vesting = {
  authorities: ['active'],
  description:
`

`,
  params: {
    from,
    to,
    amount
  }
}

/**
 * update_proposal_votes
 */
const update_proposal_votes = {
  authorities: ['active'],
  description:
`

`,
  params: {
    voter,
    proposal_ids,
    approve,
    extensions
  }
}

/**
 * vote
 */
const vote = {
  authorities: ['posting'],
  description:
`

`,
  params: {
    voter,
    author,
    permlink,
    weight
  }
}

/**
 * withdraw_vesting
 */
const withdraw_vesting = {
  authorities: ['active'],
  description:
`

`,
  params: {
    account,
    vesting_shares
  }
}

/**
 * witness_update
 */
const witness_update = {
  authorities: ['active'],
  description:
`
Example for props:
{"account_creation_fee": "3.000 STEEM","maximum_block_size":65536,"sbd_interest_rate":0}
`,
  params: {
    owner: witness,
    url,
    block_signing_key,
    props,
    fee
  }
}

/**
 * witness_set_properties
 */
const witness_set_properties = {
  authorities: ['signing'], //should be signed with the same signing_key defined in the operation
  description:
`
Example for props:
{"account_creation_fee":"3.000 STEEM","account_subsidy_budget":10000,"account_subsidy_decay":330782,"maximum_block_size":65536,"sbd_interest_rate":0,"sbd_exchange_rate":{"base":"2.500 SBD","quote":"1.000 STEEM"},"url":"http://steemit.com/","new_signing_key":"STM7T2TBdQWqNAhuzH5SXfSnsTLmrZkAufmvMwEsbvGihtHsf7dWk","key":"STM7T2TBdQWqNAhuzH5SXfSnsTLmrZkAufmvMwEsbvGihtHsf7dWk"}
`,
  params: {
    owner: witness,
    props,
    extensions
  }
}

/**
 * steem engine issue
 */
const steem_engine_issue = {
  authorities: ['active'],
  description:
`

`,
  contract: 'tokens',
  action: 'issue',
  params: {
    _account: account,
    to,
    quantity,
    symbol
  }
}

/**
 * steem engine transfer
 */
const steem_engine_transfer = {
  authorities: ['active'],
  description:
`

`,
  contract: 'tokens',
  action: 'transfer',
  params: {
    _account: account,
    to,
    quantity,
    symbol,
    memo
  }
}

/**
 * steem engine buy
 */
const steem_engine_buy = {
  authorities: ['active'],
  description:
`

`,
  contract: 'market',
  action: 'buy',
  params: {
    _account: account,
    symbol,
    quantity,
    price
  }
}

/**
 * steem engine sell
 */
const steem_engine_sell = {
  authorities: ['active'],
  description:
`

`,
  contract: 'market',
  action: 'sell',
  params: {
    _account: account,
    symbol,
    quantity,
    price
  }
}

/**
 * steem engine cancel
 */
const steem_engine_cancel = {
  authorities: ['active'],
  description:
`

`,
  contract: 'market',
  action: 'cancel',
  params: {
    _account: account,
    type: type_se,
    id: id_se
  }
}

/**
 * steem engine stake
 */
const steem_engine_stake = {
  authorities: ['active'],
  description:
`

`,
  contract: 'tokens',
  action: 'stake',
  params: {
    _account: account,
    to,
    symbol,
    quantity
  }
}



var operations = {
  // ACCOUNT
  account_create,
  //account_create_with_delegation,
  account_update,
  account_update2,
  change_recovery_account,
  claim_account,
  create_claimed_account,
  decline_voting_rights,
  recover_account,
  request_account_recovery,

  // POSTS
  comment,
  comment_options,
  delete_comment,
  vote,
  claim_reward_balance,
  delegate_vesting_shares,

  // WALLET
  transfer,
  convert,
  transfer_to_vesting,
  withdraw_vesting,
  set_withdraw_vesting_route,
  transfer_from_savings,
  transfer_to_savings,
  cancel_transfer_from_savings,

  // ESCROW
  escrow_transfer,
  escrow_approve,
  escrow_release,
  escrow_dispute,

  // MARKET
  limit_order_create,
  limit_order_create2,
  limit_order_cancel,

  // CUSTOM
  custom,
  custom_binary,
  custom_json,

  // WITNESS
  witness_update,
  witness_set_properties,
  feed_publish,
  account_witness_vote,
  account_witness_proxy,

  // SPS
  create_proposal,
  remove_proposal,
  update_proposal_votes,

  // STEEM ENGINE
  steem_engine_issue,
  steem_engine_transfer,
  steem_engine_buy,
  steem_engine_sell,
  steem_engine_cancel,
  steem_engine_stake,
}

var prettyName = (n)=>{
  n = n.replace(/json/g, 'JSON')
  return ( n.charAt(0).toUpperCase() + n.substring(1) ).replace(/_/g, ' ')
}

var DEBUG = false

var listTypes = []
for(var i in operations){
  var op = operations[i]
  op.name = prettyName(i)
  op.operation = i
  if(!op.optional) op.optional = []
  for(var j in op.params){
    var param = op.params[j]
    param.name = prettyName(j)
    param.value = ''
    param.use_it = true
    switch(param.type){
      case 'asset':
      case 'account':
      case 'string':
      case 'public_key':
      case 'number':
      case 'time':
      case 'float-string':
        param.typeUI = 'text'
        break
      case 'textarea':
      case 'buffer':
      case 'json':
      case 'object':
        param.typeUI = 'textarea'
        break
      case 'boolean':
        param.typeUI = 'checkbox'
        break
      default:
        throw new Error(`No typeUI defined for the type '${param.type}'`)
    }
    if(DEBUG){
      var type = listTypes.find( (t)=>{return t === param.type} )
      if(!type) listTypes.push(param.type)
    }
  }
}

if(DEBUG) console.log(listTypes)

operations.comment.name = 'Post/Comment'

export default operations
